import type { ConsolePageOption, ConsolePageService, Plugin } from '@/plugins'
import { CORE_PLUGIN } from '@/core'
import {
  container,
  injectable,
  instanceCachingFactory,
  registry,
  singleton,
} from 'tsyringe'
import type { App } from 'vue'
import Comment from './view/Comment.vue'
import CommentDetail from './view/CommentDetail.vue'
import { PLUGIN_CONSOLE_PAGE } from '@/plugins/builtin/BuiltinPluginSymbol'
/**
 * 插件的Option定义
 */
@singleton()
@registry([
  {
    token: CORE_PLUGIN,
    useFactory: instanceCachingFactory<Plugin<unknown, unknown>>((c) =>
      c.resolve(CommentPagePlugin)
    ),
  },
])
@injectable()
export class CommentPagePlugin implements Plugin<unknown, unknown> {
  id: string | symbol = ''
  options: unknown
  service: unknown

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  init(app: App<Element>): void {
    const plugin =
      container.resolve<Plugin<ConsolePageOption, ConsolePageService>>(
        PLUGIN_CONSOLE_PAGE
      )
    plugin.service.addChildRoute({
      path: 'accounts/comment',
      component: Comment,
      meta: {
        keepAlive: true
      }
    })
    plugin.service.addChildRoute({
      path: 'accounts/comment/:id',
      component: CommentDetail
    })
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  initialized(app: App<Element>): void {

  }
}
